import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { Input } from '@naf/input';
import { Button } from '@naf-simba/elements-buttons';
import { breakpoints, spacing } from '@naf/theme';

export const Wrapper = styled.div`
  margin-top: ${spacing.space48};

  @media (max-width: ${breakpoints.s}) {
    margin-top: 0;
  }
`;

export const Layout = styled.div`
  display: grid;
  grid-template-areas: 'filter content';
  grid-template-columns: 1fr 4fr;
  grid-gap: ${spacing.space32};
  align-items: start;

  @media (max-width: ${breakpoints.s}) {
    grid-template-areas: 'filter' 'content';
    grid-template-columns: 1fr;
  }
`;

export const Content = styled.div`
  grid-area: content;
`;

export const StyledH4 = styled(Text)`
  margin-bottom: ${spacing.space16};
`;

export const StyledInput = styled(Input)`
  width: 151px;
  height: 48px;

  @media (max-width: ${breakpoints.s}) {
    width: 120px;
  }
`;

export const SearchButton = styled(Button)`
  height: ${spacing.space48};
  padding: 0 ${spacing.space24};
  margin-left: ${spacing.space16};
  white-space: nowrap;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 300;
`;
